<script setup>
import { storeToRefs } from "pinia" // import storeToRefs helper hook from pinia
import { useAuthStore } from "~/store/auth" // import the auth store we just created
// const { data: prod } = await $fetch("/api/products")

const { authenticated } = storeToRefs(useAuthStore()) // make authenticated state reactive with storeToRefs
const authStore = useAuthStore() // use authenticateUser action from  auth store
console.log("auth", authenticated)
console.log(await authStore.getSession)
const session = await authStore.getSession
const prod = ref({})
onMounted(async () => {
  const vote = await $fetch(`/api/products`, {
    method: "post",
    body: {
      uid: authStore.getUid,
      password: authStore.getPassword,
    },
  })
  console.log(vote)
  prod.value = vote
})
</script>

<template>
  <div>About Page</div>
  ddd{{ prod }} eee
</template>
<script lang="ts" setup></script>
